"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewEntityDetail = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Text_1 = require("../Text");
var styles_1 = __importDefault(require("./styles"));
var colors_1 = require("../../themes/main/colors");
exports.ViewEntityDetail = react_1.default.memo(function (_a) {
    var title = _a.title, _b = _a.value, value = _b === void 0 ? '' || [] : _b, _c = _a.titleProps, titleProps = _c === void 0 ? { color: colors_1.materialColors.grey[500] } : _c, _d = _a.valueProps, valueProps = _d === void 0 ? {} : _d, multiLine = _a.multiLine, _e = _a.Component, Component = _e === void 0 ? Text_1.Text : _e, children = _a.children;
    var classes = (0, styles_1.default)();
    return ((0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ sx: {
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '6px',
            whiteSpace: 'pre-line'
        } }, { children: [(0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ className: classes.title }, titleProps, { children: title })), multiLine ? ((0, jsx_runtime_1.jsxs)("div", __assign({ style: { display: 'flex', flexDirection: 'column' } }, { children: [Array.isArray(value) &&
                        value.map(function (v) { return ((0, jsx_runtime_1.jsx)(Component, __assign({ className: classes.content, value: v }, valueProps, { children: v === '' ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "\u00A0" }) : v }), v)); }), children] }))) : ((0, jsx_runtime_1.jsxs)(Component, __assign({ className: classes.content, value: value }, valueProps, { children: [value, children] })))] })));
});
